
import axios from "axios";
import { getApiUrl, getApiDataUrl } from "../utils/platform";
import { getToken } from "../utils/token";

const get = (url, data = {}, headers = null) => {
    const accessToken = getToken();
    if (accessToken) axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    return axios.get(url);
}

const getHey = (url, data = {}, accessToken) => {
    if (accessToken) axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    return axios.get(url);
}

const post = (url, data = {}, headers = null) => {
    const accessToken = getToken();
    if (accessToken) axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    return axios.post(url, data);
}

const put = (url, data = {}, headers = null) => {
    const accessToken = getToken();
    if (accessToken) axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    return axios.put(url, data);
}

const del = (url, headers = null) => {
    const accessToken = getToken();
    if (accessToken) axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    return axios.delete(url);
}

// Helper function to get the appropriate base URL
const getBaseUrl = (endpoint) => {
    // If endpoint starts with /api/data, use data URL
    if (endpoint.startsWith('/api/data')) {
        return getApiDataUrl();
    }
    // Otherwise use main API URL
    return getApiUrl();
};

export const API = {
    get,
    getHey,
    post,
    put,
    delete: del,
    // Add helper method to build full URLs
    buildUrl: (endpoint) => {
        return `${getBaseUrl(endpoint)}${endpoint}`;
    }
};
